var map = {
	"./+.svg": "q+7T",
	"./-.svg": "it3A",
	"./404.svg": "M58l",
	"./500.svg": "d5pt",
	"./Administracion.svg": "m337",
	"./Alerta_2.svg": "a3u+",
	"./ArrowBack.svg": "bTxt",
	"./ArrowNext.svg": "QMqd",
	"./ArrowPrev.svg": "7xRu",
	"./Bandera.svg": "pESk",
	"./BbPlusLogo.svg": "zEkJ",
	"./BigboxSquareLogo.svg": "10rW",
	"./Buena.svg": "AzWO",
	"./Calendar-Selected.svg": "PDA2",
	"./Calendar.svg": "wf2+",
	"./Cambio.svg": "/qLt",
	"./Chevron.svg": "e9eA",
	"./Chevron_red.svg": "DuCF",
	"./Copy.svg": "vUZD",
	"./Copy2.svg": "WXT4",
	"./Correo.svg": "8qAw",
	"./DefaultProfile.svg": "gtxf",
	"./Delivery.svg": "PNE+",
	"./Elegi.svg": "ouVF",
	"./Emoji_excitado.svg": "4fS0",
	"./Excelente.svg": "/ZTc",
	"./Experiencias.svg": "bHwY",
	"./Eye.svg": "kyr6",
	"./Eye_Off.svg": "xAhf",
	"./Filter.svg": "m6vP",
	"./Gift.svg": "xrq0",
	"./Gift2.svg": "WyWV",
	"./Gift_primary.svg": "pveT",
	"./Grayfilter.svg": "1Mpi",
	"./HandPulsing.svg": "LAT2",
	"./Happy.svg": "uvrx",
	"./Laptop.svg": "Rr79",
	"./LaptopPerspective.svg": "ZPbf",
	"./LikeHand.svg": "1gLp",
	"./Like_outline.svg": "BDgo",
	"./Line.svg": "MaXG",
	"./Mail.svg": "5zPG",
	"./Mala.svg": "NZPn",
	"./More.svg": "HdCp",
	"./Neutral.svg": "HYvX",
	"./NewWindow.svg": "2dFP",
	"./PDP/chevron.svg": "OxLN",
	"./PDP/gift_circle.svg": "z+Nr",
	"./PDP/message_circle.svg": "3tiu",
	"./PDP/timer_circle.svg": "n3BT",
	"./Pappers_primary.svg": "X/xO",
	"./PartyPopper.svg": "EqQh",
	"./Persona1.svg": "40eA",
	"./Pesima.svg": "zzyN",
	"./Plus.svg": "UAu2",
	"./SearchBarIcons/Outline_ArgentinaFlag.svg": "73rP",
	"./SearchBarIcons/Outline_Balloon.svg": "npgi",
	"./SearchBarIcons/Outline_Birthday.svg": "rkBk",
	"./SearchBarIcons/Outline_BookOpen.svg": "ippQ",
	"./SearchBarIcons/Outline_CalendarHeart.svg": "fAFZ",
	"./SearchBarIcons/Outline_Compass.svg": "LOq+",
	"./SearchBarIcons/Outline_Default.svg": "6ULN",
	"./SearchBarIcons/Outline_Diamond.svg": "aEM9",
	"./SearchBarIcons/Outline_Flower.svg": "/WXx",
	"./SearchBarIcons/Outline_HandHeart.svg": "X2It",
	"./SearchBarIcons/Outline_HarmonieHeart.svg": "tHv1",
	"./SearchBarIcons/Outline_Heart.svg": "7p8z",
	"./SearchBarIcons/Outline_KnifeFork.svg": "RQaH",
	"./SearchBarIcons/Outline_Lightning.svg": "9FcD",
	"./SearchBarIcons/Outline_MapPin.svg": "Xq55",
	"./SearchBarIcons/Outline_Reservation.svg": "jMY6",
	"./SearchBarIcons/Outline_Smile.svg": "D137",
	"./SearchBarIcons/Outline_Star.svg": "1yZB",
	"./SearchBarIcons/Outline_Sun.svg": "37/p",
	"./SearchBarIcons/Outline_Ticket.svg": "yjyS",
	"./SmilingFace.svg": "SQL+",
	"./Tecnologia.svg": "Bh55",
	"./Tick.svg": "yw4H",
	"./UnboxingCompanyLogoTest.svg": "C0kI",
	"./Vector.svg": "DVc5",
	"./Ventas.svg": "6MRG",
	"./activity_signal.svg": "6/5s",
	"./alert-red.svg": "7wSC",
	"./alert.svg": "7J7D",
	"./alerta2.svg": "8i1P",
	"./alliance.svg": "vYS5",
	"./arrow-left.svg": "AfE3",
	"./arrow-reload.svg": "duvK",
	"./bigbox.svg": "uKe9",
	"./bookmark-icon.svg": "1tft",
	"./box.svg": "eVM4",
	"./boxLocation.svg": "uSUK",
	"./boxperspective.svg": "RGUQ",
	"./calendarSpain.svg": "x0tR",
	"./calendar_bold.svg": "zMEL",
	"./calendar_days.svg": "HCUy",
	"./calendar_gray.svg": "V9uW",
	"./califica.svg": "YL6W",
	"./capture-audio.svg": "xzOh",
	"./capture-camera.svg": "e7Og",
	"./check.svg": "Fza3",
	"./check2.svg": "prTi",
	"./click.svg": "LLh+",
	"./clients.svg": "w3g0",
	"./clock-2.svg": "HS09",
	"./clock.svg": "WSo7",
	"./close_gray.svg": "R6r2",
	"./conversation.svg": "8dBi",
	"./corona.svg": "ydCd",
	"./corporate.svg": "E6TD",
	"./cross.svg": "FBLY",
	"./downloadArrow.svg": "hrC6",
	"./editar.svg": "mLkM",
	"./efectivo.svg": "sJUt",
	"./email.svg": "sP0n",
	"./error.svg": "8CFE",
	"./estado_cancel_icon.svg": "QOvL",
	"./estado_error_icon.svg": "lC6h",
	"./estado_pending_icon.svg": "u/hv",
	"./estado_success_icon.svg": "FCOJ",
	"./facebook.svg": "uFsX",
	"./facebook_account.svg": "u5tH",
	"./filterIcon.svg": "pfva",
	"./fireworks.svg": "DaRN",
	"./first_step_reminder.svg": "ShkT",
	"./flat.svg": "QzHW",
	"./gift_gray.svg": "ZBV7",
	"./giftcard.svg": "Wmmt",
	"./giftcard_2.svg": "sXiN",
	"./google-icon.svg": "PyTT",
	"./groupBuyers.svg": "/Mrf",
	"./hamburger-icon.svg": "i12V",
	"./hamburger.svg": "q0t1",
	"./hands-shiny.svg": "ijIM",
	"./hands.svg": "wAiH",
	"./heart.svg": "nA6A",
	"./hoverQuestion.svg": "YsfU",
	"./icon_arrow.svg": "86zC",
	"./icon_arrow_account.svg": "e9Lw",
	"./icon_gift.svg": "dWvz",
	"./inviteOther.svg": "GlSH",
	"./knowWhat.svg": "lR1P",
	"./location-red.svg": "9uoF",
	"./location.svg": "vr9K",
	"./logo_bigbox_darkgrey.svg": "8+4A",
	"./logo_bigbox_white.svg": "EFHq",
	"./mas-naranja.svg": "FWVq",
	"./mas.svg": "ccYd",
	"./media-image.svg": "LsjV",
	"./message.svg": "7cuE",
	"./messageOpen.svg": "LcIV",
	"./microphone-primary.svg": "0lz+",
	"./microphone.svg": "hMeg",
	"./mobile.svg": "G7al",
	"./moño.svg": "6qvW",
	"./multimedia-audio.svg": "Iim5",
	"./multimedia-photo.svg": "NcmK",
	"./multimedia-upload.svg": "/4Tq",
	"./multimedia-video.svg": "vT6N",
	"./parachute.svg": "O4Ct",
	"./personas-para-2.svg": "JBuO",
	"./photo.svg": "dvHt",
	"./puntodeventa.svg": "35GX",
	"./question_2.svg": "rnUU",
	"./reminder_logo.svg": "VmAs",
	"./remove-user.svg": "u88k",
	"./restart.svg": "l3Ek",
	"./return-purchase.svg": "LDoJ",
	"./reviews.svg": "+AiP",
	"./sales.svg": "MI7Q",
	"./search-icon.svg": "3dfQ",
	"./search_icon_new.svg": "IAPA",
	"./second_step_reminder.svg": "m5Yu",
	"./share.svg": "i4iq",
	"./shareGray.svg": "lWC1",
	"./shopping-bag-icon.svg": "kZiU",
	"./shopping-bag.svg": "Yza+",
	"./shout.svg": "neJf",
	"./shuffle.svg": "6F+Q",
	"./star.svg": "UcLn",
	"./star2.svg": "9bov",
	"./store.svg": "8dPD",
	"./store_white.svg": "Bi6D",
	"./success.svg": "0kff",
	"./suitcase.svg": "LSHi",
	"./takedown.svg": "T8lo",
	"./tap.svg": "rTlm",
	"./third_step_reminder.svg": "vy6D",
	"./ticket.svg": "NsRV",
	"./trending_up.svg": "/lMU",
	"./triste.svg": "JEDX",
	"./user.svg": "oTom",
	"./usuario-01.svg": "qOP7",
	"./video.svg": "eDHL",
	"./web-browser.svg": "77UE",
	"./whatsapp.svg": "7b61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dNYx";